import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { ErrorService } from '../../services/error.service';

@Component({
	selector: 'copo-feedback-error',
	templateUrl: './feedback-error.component.html',
	styleUrl: './feedback-error.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, MatIconModule, TranslateModule]
})
export class FeedbackErrorComponent implements OnDestroy {
	errorMessage = '';
	errorTitle = '';
	private readonly errorSub: Subscription;

	constructor(private readonly errorService: ErrorService) {
		this.errorSub = this.errorService.errMsgObs.subscribe(err => {
			this.errorMessage = err.message;
			this.errorTitle = err.title;
		});
	}

	ngOnDestroy() {
		this.errorSub.unsubscribe();
	}
}
